var THUMBNAILS_ALIGNMENT = {
    BOTTOM: 'bottom',
    LEFT: 'left',
    TOP: 'top',
    RIGHT: 'right',
};
export default THUMBNAILS_ALIGNMENT;
//# sourceMappingURL=thumbnailsAlignment.js.map